<script setup lang="ts">
import { Toaster as Sonner } from 'vue-sonner'
import type { ToasterProps } from 'vue-sonner'

const props = withDefaults(
  defineProps<ToasterProps>(),
  {
    position: 'top-center',
    expand: true,
    richColors: true,
    closeButton: false,
  },
)
</script>

<template>
  <Sonner v-bind="props" />
</template>

